export default "__VITE_ASSET__DqAqJxRK__"